import { logEvent } from "@actions";
import ReactGA from "react-ga4";
import { IS_PROD } from "@utils/constants";

export const COMPLETE_FORMS_PATH = "/complete-forms";

export function openCompleteForms() {
  logEvent("intakeCompleteFormsButtonClicked");
  if (IS_PROD) {
    ReactGA.event({ action: "complete_forms_clicked", category: "marketing_funnel" });
  }
  window.open(COMPLETE_FORMS_PATH, "_blank", "noopener,noreferrer");
}
